import * as api from '../../../api/color/colorApi';
import {
  FETCH_COLORS_REQUEST,
  FETCH_COLORS_SUCCESS,
  FETCH_COLORS_FAILURE,
  // CREATE_COLOR,
  // UPDATE_COLOR,
  // DELETE_COLOR,
  CREATE_COLOR_REQUEST,
  CREATE_COLOR_SUCCESS,
  CREATE_COLOR_FAILURE,
  UPDATE_COLOR_REQUEST,
  UPDATE_COLOR_SUCCESS,
  UPDATE_COLOR_FAILURE,
  DELETE_COLOR_REQUEST,
  DELETE_COLOR_SUCCESS,
  DELETE_COLOR_FAILURE
} from '../../types/color/colorTypes';

export const fetchColors = () => async (dispatch) => {
  dispatch({ type: FETCH_COLORS_REQUEST });
  try {
    const response = await api.fetchColors();
    dispatch({ type: FETCH_COLORS_SUCCESS, payload: response.data });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch colors';
    dispatch({ type: FETCH_COLORS_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const createColor = (data) => async (dispatch) => {
  dispatch({ type: CREATE_COLOR_REQUEST });
  try {
    const response = await api.createColor(data);
    dispatch({ type: CREATE_COLOR_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to create color';
    dispatch({ type: CREATE_COLOR_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const updateColor = (id, data) => async (dispatch) => {
  dispatch({ type: UPDATE_COLOR_REQUEST });
  try {
    const response = await api.updateColor(id, data);
    dispatch({ type: UPDATE_COLOR_SUCCESS, payload: { id, data } });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update color';
    dispatch({ type: UPDATE_COLOR_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const deleteColor = (id) => async (dispatch) => {
  dispatch({ type: DELETE_COLOR_REQUEST });
  try {
    const response = await api.deleteColor(id);
    dispatch({ type: DELETE_COLOR_SUCCESS, payload: id });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete color';
    dispatch({ type: DELETE_COLOR_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};
